@if (product) {
  <div class="product-detail-item">
    <div class="product-detail-item__step">
      <div class="product-detail-item__step-icon">
        <mat-icon color="{{ config.state }}" matTooltip="{{ config.state }}">{{
          config.icon
        }}</mat-icon>
      </div>
    </div>
    <div class="product-detail-item__step-content">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header style="height: 64px">
          <mat-panel-title>
            <h1>{{ config.label }}</h1>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (config.showAdditional) {
          <div>
            @for (item of config.additional; track item; let idx = $index) {
              <div>
                @if (config.id == 'ingestion') {
                  <div class="sub-heading">
                    Touch {{ item.masterSuiteTouchIndex / 1000 + 1 }}:
                    {{ item.masterSuiteTouchName }}
                  </div>
                }
                <mat-grid-list cols="6" rowHeight="60" gutterSize="20">
                  @for (itemConfig of config.additionalConfig; track itemConfig) {
                    <mat-grid-tile [colspan]="itemConfig.col">
                      @if (itemConfig.type === 'text') {
                        <mat-form-field
                          appearance="outline"
                          color="primary"
                          >
                          <mat-label>{{ itemConfig.label }}</mat-label>
                          <input
                            matInput
                            [readonly]="true"
                            value="{{ item[itemConfig.value] }}"
                            />
                          @if (itemConfig.label == 'Settings Variant') {
                            <button
                              (click)="changeSettingsVariant()"
                              matSuffix
                              [disabled]="product.masterSuiteId == null"
                              mat-icon-button
                              color="success"
                              matTooltip="Change"
                              matTooltipPosition="above"
                              matBadge="!"
                              [matBadgeHidden]="product.settingsVariantId != null"
                              >
                              <mat-icon>lightbulb</mat-icon>
                            </button>
                          }
                          @if (itemConfig.label == 'Master Suite') {
                            <button
                              (click)="viewMasterSuite()"
                              matSuffix
                              [disabled]="product.masterSuiteId == null"
                              mat-icon-button
                              color="info"
                              matTooltip="Details"
                              matTooltipPosition="above"
                              >
                              <mat-icon>info</mat-icon>
                            </button>
                          }
                        </mat-form-field>
                      }
                      @if (itemConfig.type === 'number') {
                        <mat-form-field
                          appearance="outline"
                          color="primary"
                          >
                          <mat-label>{{ itemConfig.label }}</mat-label>
                          <input
                            matInput
                            [readonly]="true"
                            value="{{ item['dimensions'][itemConfig.value] }}"
                            />
                        </mat-form-field>
                      }
                      @if (itemConfig.type === 'date') {
                        <mat-form-field
                          appearance="outline"
                          color="primary"
                          >
                          <mat-label>Date</mat-label>
                          <input
                            matInput
                            [readonly]="true"
                    value="{{
                      item[itemConfig.value]
                        | dateAgo : currentConfigDate : false
                        | async
                    }}"
                            />
                        </mat-form-field>
                      }
                    </mat-grid-tile>
                  }
                </mat-grid-list>
              </div>
            }
          </div>
        }
      </mat-expansion-panel>
    </div>
  </div>
}
